import { http, HttpResponse } from 'msw'
import { UnsecuredJWT } from 'jose'

import { api } from '@/utils/constants'

import { AuthTokens } from '@/types/auth/tokens'

export const resetPassword = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.auth.RESET_PASSWORD}`,
    () => {
        const payload = {
            zer: 'aze',
        }

        const accessToken = new UnsecuredJWT(payload)
            .setIssuedAt()
            .setExpirationTime('1d')
            .encode()

        const refreshToken = new UnsecuredJWT(payload)
            .setIssuedAt()
            .setExpirationTime('15d')
            .encode()

        return HttpResponse.json<AuthTokens>({
            access_token: accessToken,
            refresh_token: refreshToken,
        })
    },
)
